import React from 'react'

const UserMessages = () => {
  return (
    <div>UserMessages</div>
  )
}

export default UserMessages